import { Interpolation, Theme } from '@emotion/react';
import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@material-ui/core';
import { forwardRef } from 'react';

export type TextFieldProps = MuiTextFieldProps & { css?: Interpolation<Theme> };

export const TextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => {
  return <MuiTextField ref={ref} {...props} />;
});
